import { h } from 'preact';
import Icon from '../../common/Icon/Icon';
import { Properties } from '../../common';
import { withStyles, WithStyles } from '../../style';

export interface DateSelectorSeparatorProps extends Properties {}

type EffectiveProps = DateSelectorSeparatorProps & WithStyles;

export default withStyles()((props: EffectiveProps): h.JSX.Element => {
  const { tx } = props;
  return (
    <div class={tx(props.class, 'flex flex--center circle')}>
      <Icon iconName="minus" class={tx('is-small')} />
    </div>
  );
});
